import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'

@Component({
  components: {}
})
export default class PayMent extends Vue {

  @Prop({ default: true }) showPSE;
  @Prop({ default: true }) showPaymentLink;
  @Prop({ default: null }) currentPayment;

  // Action
  @Action action_deleteCreditCard: any

  // Getters
  @Getter getCreditCards: any
  @Getter getCountry

  payment = ''

  @Watch('currentPayment', { deep: true })
  onPaymentMethodChange() {
    this.payment = {...this.currentPayment};
  }

  mounted() {
    if(!this.currentPayment) {
      this.setPaymentMethod("cash", "default", null);
    }
  }

  get isPse() {
    let response = false;
    if (
      this.getCountry &&
      this.getCountry.available_payment_methods_for_delivery &&
      this.getCountry.available_payment_methods_for_delivery.length
    ) {
      const index = this.getCountry.available_payment_methods_for_delivery.findIndex(
        (method) => method === "PSE"
      );
      if (this.showPSE && index !== -1) {
        response = true;
      }
    }
    return response;
  }

  async _delete (value: any) {
    try {
      let alert = await this.$swal({
        title: 'Confirmar',
        text: '¿Deseas eliminar la tarjeta de credito ***' + value.credit_card_number,
        showCancelButton: true,
        confirmButtonText: 'Aceptar'
      })
      if (alert.value) {
        await this.action_deleteCreditCard(value.id)
      }
    } catch (error) {
      const status = error.response.status
      if (status >= 500) {
        this.$swal({
          title: 'Error al eliminar tarjeta.',
          text: `Problemas con el servidor. Error ${status}`
        })
      } else {
        this.$swal({
          title: 'Error al eliminar tarjeta.',
          text: error.response.data.message
        })
      }
    }
  }

  _iconCard(value) {
    let icon = "ceu-icon-visacard";
    switch (value) {
      case "MASTERCARD":
        icon = "ceu-icon-mastercard";
        break;
      case "AMEX":
        icon = "ceu-icon-american-express";
        break;
    }
    return icon;
  }

  isCurrentPaymentMethod(method, isCreditCard) {
    let response = false;
    if(isCreditCard && method && method.id) {
      if (
        this.currentPayment &&
        this.currentPayment.card &&
        this.currentPayment.card.id &&
        this.currentPayment.card.id == method.id
      ) {
        response = true;
      }
    } else if (!isCreditCard && method && !method.card) {
      if (
        method.type &&
        this.currentPayment &&
        this.currentPayment.type &&
        this.currentPayment.type == method.type
      ) {
        response = true;
      }
    }
    return response;
  }

  setPaymentMethod(type, card, value) {
    const obj = {
      card: card,
      type: type,
      value: value
    };
    this.$emit('onChange', obj);
  }

  _addNewCard() {
    this.$emit('addNewCard');
  }
}
